import { prop } from 'ramda'
import React from 'react'

import ConditionValueInput from './ConditionValueInput'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Select from '../../../components/form/Select'
import PlacesLoader from '../../../modules/checklists/edit/_load/PlacesLoader'

const ConditionInput = ({ field, type, value: condition, onChange, ...customProps }) => {
  const value = prop(field, condition)
  const operator = prop('operator', condition)

  const commonInputProps = { value, operator, type, ...customProps }

  const handleFieldChange = (innerOperator, innerValue) => {
    if ([undefined, null].includes(innerOperator) && [undefined, null].includes(innerValue)) return
    if (innerOperator === 'within_places_ids') innerValue = innerValue.map(item => item.id)
    onChange({
      field,
      operator: innerOperator || operator,
      value: innerValue !== undefined ? innerValue : value
    })
  }

  switch (type) {
    case 'checkbox':
      return <ConditionValueInput onChange={v => handleFieldChange('eq', v)} {...commonInputProps} />

    case 'select':
    case 'multiple':
      return <ConditionValueInput onChange={v => handleFieldChange('within_refs', v)} {...commonInputProps} />

    case 'float':
    case 'numeric':
    case 'calc':
      return (
        <FlexGrid gutter={0.4}>
          <FlexCol flex={2}>
            <Select
              onChange={handleFieldChange}
              value={operator}
              disableEmptyOption
              {...customProps}
              options={[
                { label: 'Igual a', value: 'eq' },
                { label: 'Maior que', value: 'gt' },
                { label: 'Maior ou igual a', value: 'gte' },
                { label: 'Menor que', value: 'lt' },
                { label: 'Menor ou igual a', value: 'lte' },
                { label: 'Entre', value: 'btwn' },
                { label: 'Não está entre', value: 'nbtwn' }
              ]}
            />
          </FlexCol>
          <FlexCol flex={2}>
            <ConditionValueInput onChange={v => handleFieldChange(operator || 'eq', v)} {...commonInputProps} />
          </FlexCol>
        </FlexGrid>
      )

    case 'place':
      return (
        <PlacesLoader
          noEmptyMessage
          uncontrolledChildren={
            <ConditionValueInput onChange={v => handleFieldChange('within_places_ids', v)} {...commonInputProps} />
          }
        />
      )

    default:
      return false
  }
}

export default ConditionInput
